import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import i18n from '../../i18n/i18n.js';
import PageHeader from "../../components/PageHeader/PageHeader.js";
import RecommendedProducts from '../../components/RecommendedProducts/RecommendedProducts.js';
import NewsletterSubscribe from '../../components/NewsletterSubscribe/NewsletterSubscribe.js';
import { ReactSVG } from "react-svg";
import { Utils } from '../../Utils.js';
import TypedLink from '../../components/TypedLink/TypedLink.js';
import { motion } from "framer-motion";

import { Swiper, SwiperSlide } from 'swiper/react';
import { Scrollbar } from 'swiper/modules';

import './Product.css';
import 'swiper/css';
import 'swiper/css/scrollbar';

const Product = () => {

  const location = useLocation();
  const [serverData, setServerData] = useState({});
  const [stockInfoLoading,setStockInfoLoading] = useState({loading:0})
  const [selectIsOpen,setSelectIsOpen] = useState({is_open:0});
  const [sizeTableOpen,setSizeTableOpen] = useState({is_open:0});

  useEffect(() => {

    setServerData({loaded:0,stock_info_visible:0});

    Utils.get_server_data(location.pathname).then((resp) => {
      setServerData(resp);
    });

  }, [location]);

  
  function change_product_size(e)
  {
    if(e.target && e.target.value)
    {
      const selected_id = e.target.value;
      const tmp_srv_data = {...serverData};
      const product = get_product();

      const grouped_items_save = {...product.grouped_products};

      Object.keys(product.grouped_products).forEach((e,f)=>{
        
        const grouped_item = product.grouped_products[e];

        if(grouped_item.id===selected_id)
        {
          grouped_item.grouped_products = grouped_items_save;

          tmp_srv_data.products.detail.products = [grouped_item];
          tmp_srv_data.stock_info_visible = 0;
          tmp_srv_data.stock_info = null;

          return setServerData(tmp_srv_data);
        }

      });
    }
  }

  function get_product_stock_info(product_code)
  {
    if(serverData.stock_info_visible === 1)
    {
      const tmp_srv_data = {...serverData};
      tmp_srv_data.stock_info_visible = 0;
      setServerData(tmp_srv_data);
    }
    else
    {
      if((serverData.stock_info && Object.keys(serverData.stock_info.stocks).length>0))
      {
        const tmp_srv_data = {...serverData};
        tmp_srv_data.stock_info_visible = 1;
        setServerData(tmp_srv_data);
      }
      else
      {
        setStockInfoLoading({loading:1});
        Utils.get_server_data(location.pathname,{},{'ajax_event':'get_stock_info','product_code':product_code}).then((resp) => {
          if(resp.stock_info){
            const tmp_srv_data = {...serverData};
            tmp_srv_data.stock_info = resp.stock_info;
            tmp_srv_data.stock_info_visible = 1;
            setServerData(tmp_srv_data);
            setStockInfoLoading({loading:0});
          }
        });
      }
    }
  }

  function get_product()
  {
    return (serverData.products && serverData.products['detail'] &&  serverData.products['detail'].products[0]) ? serverData.products['detail'].products[0] : [];
  }

  function videoClick(e){
    var vid = e.target; // DOM HTMLVideoElement
    try {
      if (vid.paused) {
        var playPromise = vid.play();
        if (playPromise !== undefined) {
          playPromise.catch(function (err) {
            // play prevented (e.g. autoplay policy) — handle/log if needed
            console.warn("Video play prevented:", err);
          });
        }
      } else {
        vid.pause();
      }
    } catch (err) {
      console.error("Video control error:", err);
    }
  }

  function render_header_images_slider(){

    const product = get_product();
    const color_codes = [];

    return <div className='details_images_slider_cont'>
      {
        (typeof product.product_images != 'undefined' && product.product_images.length>0)
        ?
        <Swiper
          scrollbar={{  
          draggable: true
          }}
          modules={[Scrollbar]}
          className='details_images_slider'>
            {product.video_file ?
              <SwiperSlide key={'video_'+product.id} className="slider_item">
                <video muted loop autoPlay playsInline onClick={(e)=>{ videoClick(e); }}>
                  <source src={process.env.REACT_APP_ORIGINAL_SHOP_URL+'/upload_files/products_videos/'+product.video_file} type="video/mp4" />
                </video>
              </SwiperSlide>
            : ''}
            {product.product_images.map((value,index)=>{
              return <SwiperSlide key={value.thumb_detailed_hr_.filename} className="slider_item">
                <img src={process.env.REACT_APP_ORIGINAL_SHOP_URL+'/'+value.thumb_detailed_hr_.filename} alt="asd" />
              </SwiperSlide>
            })}
        </Swiper>
        : ''
      }
      
      {
        (typeof product.grouped_products != 'undefined' && product.grouped_products.length>0 && product.color_variants_count>1) 
        ?
          <div className='color_variants_cont'>
            <div className='color_variants_inner'>
            {product.grouped_products.map((value,index)=>{
              if(color_codes[value.product_color_code]){
                return '';
              }else{
                color_codes[value.product_color_code] = true;
                return <TypedLink key={value.id} link={{'type':'product','url':value.url}}>
                  <img src={process.env.REACT_APP_ORIGINAL_SHOP_URL+'/'+value.product_image[0].thumb_.filename} alt=""/>
                </TypedLink>
              }
            })} 
            </div>
          </div>
        : <div className="no_coloros"></div> 
      }
      

    </div>;
  }

  function get_past30day_bestprice()
  {
    const product = get_product();

    return i18n.t('productDetailsPast30DayBestPrice').replace('{price}',product.c_price);
  }

  function show_editor_size_table() {
    window.AppRef.current.get_settings().then((resp)=>{
      var settings = resp.settings;

      Utils.get_server_data(
        '/content/' + settings.settings.WS_URL_MERETTABLAZATOK, 
        {ajax_event: 'content', APICACHE: 'false'}, 
        {}
      ).then(res => {
        window.modals.PopupContentRef.current.show(res);
      }); 
    });
    
  }

  function render_product_details_and_description(){

    const product = get_product();
    let breadcrumb_url = '';

    return <div className='details_cont'>
      <div className='category_breadcrumb'>
        {
          (!!serverData.breadcrumb && serverData.breadcrumb.length>0)
          ?
          serverData.breadcrumb.map((val,index)=>{
            breadcrumb_url+='/'+val.magyar_url;
            if(val && val.type!=='products'){
              return <span key={val.id}><TypedLink link={{'type':'products','url':breadcrumb_url,'title':val.label}}></TypedLink> <span className='bc_separator'> / </span></span>
            }else{
              return '';
            }
          })
          : ''
        }
      </div>
      <h1 className='product_name'>{product.product}</h1>
      <div className='price_cont'>
        <div className='price'>
          <b className={`${!!product.sale ? 'stroked' : ''}`}>{(product.sale!==0) ?  product.price_original_gross : product.price_gross}</b>
          {!!product.sale ? <b className="sale">{product.price_gross}</b> : ''}
        </div>
      </div>
      <div className='last_30_days_price'>{get_past30day_bestprice()}</div>
      {product.specification_blob_hu ? <div className='description' dangerouslySetInnerHTML={{__html: product.specification_blob_hu}}></div> : ''}
      <div className="properties_cont">
        <div className='prop_item'>
          <span className='prop_label'>{i18n.t('productDetailsProductCodeLabel')}</span>
          <span className='prop_value'> {product.product_code}</span>
        </div>

        {
          (product.product_material && product.product_material.product_parameter)
          ?
          <div className='prop_item'>
            <span className='prop_label'>{i18n.t('productDetailsMaterial')}</span>
            <span className='prop_value'> {product.product_material.product_parameter}</span>
          </div>
          :
          ''
        }
        
        {
          (product.product_footlength && product.product_footlength.product_parameter) ? 
          <div className='prop_item'>
            <span className='prop_label'>{i18n.t('productDetailsFootLength')}</span>
            <span className='prop_value'> {product.product_footlength.product_parameter+' cm'}</span>
          </div>
          : ''
        }
      </div>
      {<div className='size_and_mail_cont'>
        {product?.size_table_html?.length ?
          <>
            <div className={`size_table`} onClick={()=>{setSizeTableOpen({is_open:(Math.abs(sizeTableOpen.is_open-1))})}}>
              <ReactSVG src='assets/images/sizetable_2.svg'/> {i18n.t('productDetailsSizeTable')}
            </div> 
            <div className={`size_table_popup ${sizeTableOpen.is_open ? 'open' : ''}`}>
              <div class="sizetable_popup_container">
                <div class="sizetable_popup">
                  <h2>{i18n.t('sizeTablePopupTitle')}  <span class="sizetable_popup_close"><img onClick={()=>{setSizeTableOpen({is_open:(Math.abs(sizeTableOpen.is_open-1))})}} src="assets/images/sizetable_close.svg" /></span></h2>
                  <p>{i18n.t('sizeTablePopupDescription')}</p>
                  <div dangerouslySetInnerHTML={{__html: product.size_table_html}}></div> 
                </div>
              </div>
            </div>
          </>
        : <>
          <div className={`size_table`} onClick={()=>{show_editor_size_table()}}>
            <ReactSVG src='assets/images/sizetable_2.svg'/> {i18n.t('productDetailsSizeTable')}
          </div> 
        </>}
        {/**<div className='e_mail'>
          <ReactSVG src='assets/images/email.svg'/> {i18n.t('productDetailsEmail')}
        </div>**/}
      </div>}
      <div className='product_stock_info' onClick={()=>{get_product_stock_info(product.product_code)}}>
        <div className='stock_info_header'>{i18n.t('productDetailsShopsLabel')}</div>
        {stockInfoLoading.loading===0 ? <ReactSVG className='stock_info_icon' src='assets/images/close.svg'/> : <div className='loading-dots '></div>}
      </div>
      {render_stock_info()}
    </div>
  }

  function render_stock_info()
  {
    const variants = {
      open: { opacity: 1,  height: 'auto' },
      closed: { opacity: 0, height: 0 },
    }

    /*
    <motion.div 
    animate={serverData.stock_info_visible ? "open" : "closed"}
    transition={{ ease: "anticipate", duration: 0.4 }}
    variants={variants}>*/

    return <>
    {(serverData.stock_info_visible && serverData.stock_info && Object.keys(serverData.stock_info.stocks).length>0)
      ?
        <div className='shop_stocks_list_cont'>
          {Object.keys(serverData.stock_info.shops).map((shop_id,index)=>{
            const stock = serverData.stock_info.stocks[shop_id];
            const shop_name = serverData.stock_info.shops[shop_id];
            if(shop_name && stock>0){
              return <div key={shop_id+'_'+stock} className='shop_stock_row'><span>{shop_name}:</span><span>{stock} {i18n.t('defaultQuantity')}</span></div>
            }
          })}
        </div>
      :
      ''
    }
    </>
  }

  function render_size_selction(){

    const product = get_product();

    return <>
    {(Object.keys(product.grouped_products).length>0) ?
    <div className='size_picker_cont'>
      <div className='select'>
        <select name='size' onClick={()=>{setSelectIsOpen({is_open:(Math.abs(selectIsOpen.is_open-1))})}} onBlur={()=>setSelectIsOpen({is_open:0})} onChange={(e)=>{change_product_size(e)}} defaultValue={product.id}>
          {Object.keys(product.grouped_products).map((key,index)=>{
            const grouped_product = product.grouped_products[key];
            return (grouped_product.product_color_code === product.product_color_code) ? <option key={grouped_product.id} value={grouped_product.id}>{((grouped_product.id==product.id && selectIsOpen.is_open==0) ? i18n.t(parseInt(grouped_product.ugyfelkartya_product) === 1 ? 'productDetailsSizeSelectorAmountLabel' : 'productDetailsSizeSelectorSizeLabel')+' ' : '')+grouped_product.product_size_eu.product_parameter}</option> : ''
          })}
        </select>
        <ReactSVG src='assets/images/arrow_down.svg'></ReactSVG>
      </div>
    </div> 
    : ''}
    </> 
    
  }

  function render_product_buttons(){

    const product = get_product();
    const item_attributes = [];

    if(product.product_color.product_parameter){
      item_attributes.push(product.product_color.product_parameter);
    }

    if(product.product_size.product_parameter){
      item_attributes.push(product.product_size.product_parameter);
    }

    const is_favorite = window.AppRef.current.is_favorite_product(product);

    return <div className='buttons_cont'>

      {render_size_selction()}

      <div className='add_to_cart_button_cont'>
        <motion.a data-type="no-route" whileTap={{scale:0.95,opacity: 0.5}}
           className='button add_to_cart' onClick={()=>{Utils.add_product_to_shopping_cart(product.id,1,item_attributes.join(' / '))}} title={i18n.t('productDetailsAddToCartLabel')}>{i18n.t('productDetailsAddToCartLabel')}</motion.a>
      </div>

      {window.AppRef.current.get_is_signed() ? <div className='favorite_button_cont'>
        <motion.span whileTap={{scale:0.95,opacity: 0.5}} onClick={(e) => { window.AppRef.current[is_favorite ? 'product_fav_delete' : 'product_fav_add'](e, {product: product, on_resolve: is_favorite ? product_fav_delete : product_fav_add})}} className='button add_to_fav' title={i18n.t('productAddToFav')}>
          {i18n.t(is_favorite ? 'productAddIsFav' : 'productAddToFav')}
          <ReactSVG className='favorite_icon' src={`assets/images/${is_favorite ? 'fav_on_black' : 'fav_off_black'}.svg`}></ReactSVG>
        </motion.span>
      </div> : ''}

    </div>
  }

  function product_fav_delete(res, product) {
    setServerData({...serverData});
  }

  function product_fav_add(res, product) {
    setServerData({...serverData});
  }

  function render_icons_cont(){

    return <div className='icons_cont'>
      <div className='icon_item'>
        <div className='item_icon'><img alt={i18n.t('productDetailsIconMagyar')} src='assets/images/magyar.png' /></div>
        <div className='item_label'>{i18n.t('productDetailsIconMagyar')}</div>
      </div>
      <div className='icon_item'>
        <div className='item_icon'><img alt={i18n.t('productDetailsIconFreeShipping')} src='assets/images/delivery.png' /></div>
        <div className='item_label'>{i18n.t('productDetailsIconFreeShipping')}</div>
      </div>
      <div className='icon_item'>
        <div className='item_icon'><img alt={i18n.t('productDetailsIconFastShipping')} src='assets/images/delivery_time.png' /></div>
        <div className='item_label'>{i18n.t('productDetailsIconFastShipping')}</div>
      </div>
      <div className='icon_item'>
        <div className='item_icon'><img alt={i18n.t('productDetailsIconSwap')} src='assets/images/garancia.png' /></div>
        <div className='item_label'>{i18n.t('productDetailsIconSwap')}</div>
      </div>
    </div>

  }

  return (
    <>
      {
        (serverData.loaded===1)
        ?
        <div className={`container floating_container products_details`}>
            <PageHeader isHistoryBack="true" parent_ref={this} no_close="true" title={(serverData.title)?serverData.title:''}></PageHeader>
            <div className='products_details_inner'>
              {render_header_images_slider()}
              {render_product_details_and_description()}
              {render_product_buttons()}
              {render_icons_cont()}
              {/*<RecommendedProducts title={i18n.t('productDetailsRecommendedTitle')}/>*/}
              <NewsletterSubscribe />
              
            </div>
        </div>
        :
        <div className='loader_cont'><div className='loader'><ReactSVG src='assets/images/dorko_loader.svg'></ReactSVG></div></div>
      }
    </>
  );

};

export default Product;